export enum FeatureType {
  Dental1 = 1,
  Dental2 = 2,
  Vision = 3,
  Life = 4,
  LargeGroup = 5,
  AutoRefreshPackage = 6,
  SelectPlansMultiView = 7,
  NHWSCarrierWrap = 8
}